import React, { Component } from 'react'

interface WatermarkProps {
    message?: string;
}
export default class WaterMark extends Component<WatermarkProps> {
  render() {
    return (
        <div className={'waterMark'}>
            {this.props.message}
        </div>
    )
  }
}
